import * as React from 'react';
import HolidayManagerPage from './components/HolidayManagerPage';

export class Page extends React.Component {
    render() {
        return <HolidayManagerPage />;
    }
}